import { useRequest, API_PATH } from '../hooks/useRequest';
/**
 * ============================================
 * C端 - 活动预约状态查询接口
 * ============================================
 */
/**
 * Hook - 查询预约状态
 * @returns 包含请求函数和状态的对象
 */
export const useQueryAppointmentStatus = () => {
    return useRequest(API_PATH.QUERY_APPOINTMENT);
};
/**
 * ============================================
 * C端 - 活动预约写入接口
 * ============================================
 */
/**
 * Hook - 创建预约
 * @returns 包含请求函数和状态的对象
 */
export const useCreateAppointment = () => {
    return useRequest(API_PATH.CREATE_APPOINTMENT);
};
